// extracted by mini-css-extract-plugin
module.exports = {"widget-wrapper":"topMatchList__widget-wrapper___1EBlL"};